import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 50px 20px 50px;
`;

export const Header = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
`;

export const Title = styled(Typography.Title)`
  text-align: center;
  font-size: 22px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 50%;
  right: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  cursor: pointer;
  box-shadow: none;
  background: none;
  transform: translateY(-50%);
`;
